<template>
  <div>
    <h1 class="category-title">Top Musical Displays</h1>
    <b-container
      no-gutters
      v-for="disp in getmusicalVotes"
      v-bind:key="disp.displayid + 'musical'"
      class="display-row"
    >
      <OneDisplay v-bind:disp="disp" />
    </b-container>

    <h1 class="category-title">Top Static Displays</h1>
    <b-container
      no-gutters
      v-for="disp in getstaticVotes"
      v-bind:key="disp.displayid + 'static'"
      class="display-row"
    >
      <OneDisplay v-bind:disp="disp" />
    </b-container>

    <h1 class="category-title">Top Ohio Displays</h1>
    <b-container
      no-gutters
      v-for="disp in getOHVotes"
      v-bind:key="disp.displayid + 'OH'"
      class="display-row"
    >
      <OneDisplay v-bind:disp="disp" />
    </b-container>

    <h1 class="category-title">Top Kentucky Displays</h1>
    <b-container
      no-gutters
      v-for="disp in getKYVotes"
      v-bind:key="disp.displayid + 'KY'"
      class="display-row"
    >
      <OneDisplay v-bind:disp="disp" />
    </b-container>

    <h1 class="category-title">Top Indiana Displays</h1>
    <b-container
      no-gutters
      v-for="disp in getINVotes"
      v-bind:key="disp.displayid + 'IN'"
      class="display-row"
    >
      <OneDisplay v-bind:disp="disp" />
    </b-container>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import OneDisplay from "./OneDisplay.vue";

export default {
  name: "Category",
  components: {
    OneDisplay
  },
  methods: {
    ...mapActions(["fetchState"])
  },
  computed: {
    ...mapGetters([
      "getKYVotes",
      "getOHVotes",
      "getINVotes",
      "getmusicalVotes",
      "getstaticVotes"
    ])
  },
  created() {
    this.fetchState();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.category-title {
  margin-top:1em;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
